import React, { useState } from 'react';
import {
    OmButton,
    OmDividendCalculator,
    OmFormDropdownFieldWrapper,
    OmFormInputFieldWrapper,
} from '@om/component-library-react';
import { graphql } from 'gatsby';
import {
    getDividendCalcSelectedCountry,
    getDividendsTotal,
    getFormValid,
    getShares,
} from '@om/redux/selectors/publicWeb/dividendCalculator';
import {
    calculateDividends,
    setShares,
    setDividendCalcSelectedCountry,
} from '@om/redux/actions/publicWeb/dividendCalculator';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const DividendCalculator = ({ dividendCalculatorContent, onSelectEventFunction }) => {
    const dispatch = useDispatch();
    const { dividendsTotal, formValid, selectedCountry, shares } = useSelector(
        createStructuredSelector({
            dividendsTotal: getDividendsTotal,
            formValid: getFormValid,
            selectedCountry: getDividendCalcSelectedCountry,
            shares: getShares,
        })
    );

    if (!dividendCalculatorContent) {
        return '';
    }
    const {
        heading, 
        subheading, 
        instruction, 
        disclaimer, 
        dividend_card_group
    } = dividendCalculatorContent;

    const options = JSON.stringify(
        dividend_card_group[0].dividend_cards.map((country) => ({
            value: country.title,
            label: country.title,
        }))
    );

    const getCountrySharePrice = (index) => {
        const sharePrice = dividend_card_group[0].dividend_cards[index].share_price;
        return sharePrice;
    };
    const getCountryShareCurrenyPrefix = (index) => {
        const shareCurrenyPrefix = dividend_card_group[0].dividend_cards[index].currency_prefix;
        return shareCurrenyPrefix;
    };
    
    const getCountryShareCurrenySuffix = (index) => {
        const shareCurrenySuffix = dividend_card_group[0].dividend_cards[index].currency_suffix;
        return shareCurrenySuffix;
    };

    const getCountryIndex = (country) => {
        const index = dividend_card_group[0].dividend_cards.findIndex((x) => x.title === country);
        return {
            index: index + 1,
            share_price: getCountrySharePrice(index),
            currency_prefix: getCountryShareCurrenyPrefix(index),
            currency_suffix: getCountryShareCurrenySuffix(index),
        };
    };

    return (
        <OmDividendCalculator total-dividends={dividendsTotal}>
            {<h4 slot="heading" dangerouslySetInnerHTML={{ __html: heading }} />}
            {<h6 slot="subheading" dangerouslySetInnerHTML={{ __html: subheading }} />}
            {<h6 slot="instruction" dangerouslySetInnerHTML={{ __html: instruction }} />}


            <OmFormInputFieldWrapper
                slot="dividend-calculator-input"
                placeholder="Number of Shares"
                isSensitive={true}
                required={true}
                size="full"
                form-id="dividend-shares"
                name="shares"
                keyboard-mode="numeric"
                value={shares.value}
                state={shares.status}
                error-message={shares.error}
                onPersist={(e) => dispatch(setShares(e.detail))}
            />

            <div slot="dividend-calculator-country-dropdown">
                <OmFormDropdownFieldWrapper
                    value={selectedCountry && selectedCountry.index}
                    onOnSelect={(e) => dispatch(setDividendCalcSelectedCountry(getCountryIndex(e.detail.id)))}
                    options={options}
                />
            </div>
            <OmButton
                slot="dividend-calculator-button"
                type="primary"
                size="large"
                text="CALCULATE"
                disabled={!formValid}
                onClick={() => dispatch(calculateDividends())}
            />
            {<om-icon slot="disclaimer-icon" v-show="disclaimer_sanitized" icon-name="help"></om-icon>}
            {<h6 slot="disclaimer-text" dangerouslySetInnerHTML={{ __html: disclaimer }} />}
        </OmDividendCalculator>
    );
};

export const pageQuery = graphql`
    fragment DividendCalculator on Contentstack_dividend_calculator {
        title
        subheading
        instruction
        uid
        disclaimer
        heading
        dividend_card_group {
            title
            subheading
            uid
            heading
            dividend_cards {
                currency_prefix
                currency_suffix
                share_price
                title
                flag {
                    url
                }
            }
        }
    }
`;

export default DividendCalculator;
